export default "__VITE_ASSET__6a5595ce__"